const RANKING = [
  { rank: 1, title: '某顶流明星深夜发文回应争议', heat: '🔥 128万', tag: '24小时最热' },
  { rank: 2, title: '网红直播翻车事件最新进展追踪', heat: '🔥 106万', tag: '持续发酵' },
  { rank: 3, title: '知名企业家涉嫌财务造假被调查', heat: '🔥 98万', tag: '商业大瓜' },
  { rank: 4, title: '热门综艺录制现场突发意外事故', heat: '🔥 87万', tag: '最新爆料' },
  { rank: 5, title: '国际娱乐大奖华语作品首次入围', heat: '🔥 72万', tag: '文化热点' },
  { rank: 6, title: '社交平台热搜话题阅读量破10亿', heat: '🔥 65万', tag: '全民热议' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-3">
            吃瓜热度榜
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            51吃瓜网站实时热度排行，看看大家都在追哪些大瓜
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          {RANKING.map((item) => (
            <a
              key={item.rank}
              href="#ranking"
              className="flex items-center gap-4 py-4 px-4 rounded-lg hover:bg-background-50 transition-colors cursor-pointer group"
            >
              <span
                className={`w-8 h-8 rounded-lg flex items-center justify-center text-sm font-bold flex-shrink-0 ${
                  item.rank <= 3
                    ? 'bg-primary-500 text-white'
                    : 'bg-background-200 text-foreground-600'
                }`}
              >
                {item.rank}
              </span>
              <div className="flex-1 min-w-0">
                <p className="text-sm md:text-base text-foreground-800 font-medium group-hover:text-primary-600 transition-colors truncate">
                  {item.title}
                </p>
              </div>
              <span className="text-xs text-foreground-400 bg-background-200 px-2 py-0.5 rounded whitespace-nowrap">
                {item.tag}
              </span>
              <span className="text-xs font-semibold text-primary-600 whitespace-nowrap">{item.heat}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}